import FileUploadingIcon from '@/public/icons/record/file_uploading.svg';
import React from 'react';

import styled from '@emotion/styled';
import { keyframes } from '@emotion/react';
import { UploadingItem } from '@/recoil/atom';

type P = {
  uploadingData: UploadingItem[];
};

const UploadingFile = ({ uploadingData }: P) => {
  return (
    <>
      {uploadingData.length > 0 ? (
        <div style={{ display: 'flex', marginBottom: '8px', gap: '8px' }}>
          {uploadingData.map(({ name, percent }, idx) => (
            <div
              key={`${name}-${idx}`}
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                padding: '4px 8px 4px 4px',
                borderRadius: '4px',
                border: '1px solid var(--dk-purple-line, #EDD4EC)',
                backgroundColor: 'var(--dk-purple-soft, #F8EFF8)',
                fontSize: '12px',
                fontWeight: '400',
                lineHeight: '16px',
                width: 'fit-content',
                gap: '4px',
              }}
            >
              <IconWrapper>
                <FileUploadingIcon />
              </IconWrapper>
              <div>{name}</div>
              {/* 전송 진행률을 아는 경우에만 표시 (문서 연결 단계엔 없음) */}
              {percent !== undefined && <Percent>{percent}%</Percent>}
            </div>
          ))}
        </div>
      ) : (
        <></>
      )}
    </>
  );
};

export default UploadingFile;

const rotate360 = keyframes`
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
`;

// 퍼센트가 오르내려도 칩 너비가 흔들리지 않게 폭을 고정한다
const Percent = styled.div`
  min-width: 28px;
  text-align: right;
  font-variant-numeric: tabular-nums;
  color: var(--dk-text-secondary, #888d96);
`;

const IconWrapper = styled.div`
  width: 16px;
  height: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  animation: ${rotate360} 1.5s linear infinite;
`;
